/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateAccountInfosRequest } from '../../models/update-account-infos-request';
import { UpdateAccountInfosResult } from '../../models/update-account-infos-result';

export interface PatchAccountInfos$Params {
  body?: UpdateAccountInfosRequest;
}

export function patchAccountInfos(
  http: HttpClient,
  rootUrl: string,
  params?: PatchAccountInfos$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<UpdateAccountInfosResult>> {
  const rb = new RequestBuilder(rootUrl, patchAccountInfos.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateAccountInfosResult>;
    }),
  );
}

patchAccountInfos.PATH = '/Authentication/account-infos';
